(ns manage.adset-decision-tree-page.view.predicate-editor.timezone-util
  "Utilities for handling timezone conversions in date/time predicates."
  (:require ["moment-timezone$default" :as moment-tz]))

(defn get-decision-node-timezone
  "Gets timezone from parent decision node config.
   Returns timezone string (e.g., 'Europe/Amsterdam') or nil if not configured."
  [node-data]
  (or (get-in node-data [:config :meta :timezone])
      (get-in node-data [:config :tiktok :timezone])))

(defn get-browser-timezone
  "Gets the browser's local timezone using moment-timezone.
   Returns timezone string (e.g., 'America/New_York')."
  []
  (try
    (.guess (.-tz moment-tz))
    (catch :default _
      ;; Fallback to UTC if guess fails
      "UTC")))

(defn get-display-timezone
  "Gets the timezone to use for displaying date/time values.
   Prefers decision node timezone, falls back to browser timezone."
  [node-data]
  (or (get-decision-node-timezone node-data)
      (get-browser-timezone)))

(defn format-timezone-abbreviation
  "Formats timezone to abbreviation (e.g., 'CEST', 'PST').
   Returns the abbreviated timezone name for display."
  [timezone]
  (when timezone
    (try
      (let [m (moment-tz)]
        (.tz m timezone)
        (.format m "z"))
      (catch :default _
        ;; Fallback to showing offset if abbreviation fails
        (try
          (let [m (moment-tz)]
            (.tz m timezone)
            (.format m "Z"))
          (catch :default _
            nil))))))

(defn format-timezone-label
  "Formats a label with timezone indicator.
   Examples:
   - 'Start Date' + 'Europe/Amsterdam' -> 'Start Date (CEST)'
   - 'End Time' + nil -> 'End Time (Local Time)'"
  [label timezone]
  (if-let [tz-abbr (when timezone (format-timezone-abbreviation timezone))]
    (str label " (" tz-abbr ")")
    (str label " (Local Time)")))
